import React, { useState } from 'react';

interface HeaderProps {
  title: string;
  icon: string;
  onRefresh: () => void;
}

const Header: React.FC<HeaderProps> = ({ title, icon, onRefresh }) => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="top-header">
      <div className="header-left">
        <div className="header-logo">D</div>
        <div className="header-search">
          <span className="header-search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
      
      <div className="header-right">
        <button className="header-icon-btn" title="Notifications">
          🔔
        </button>
        <button className="header-icon-btn" title="Light Mode">
          ☀️
        </button>
        <button className="header-icon-btn" title="Dark Mode">
          🌙
        </button>
        <button className="header-icon-btn" title="Settings">
          ⚙️
        </button>
        <div className="header-user">
          <div className="header-user-avatar">A</div>
          <span style={{ fontSize: '0.75rem', color: '#a0a0a0' }}>▼</span>
        </div>
      </div>
    </div>
  );
};

export default Header;
